var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 120 39",
    style: {
      enableBackground: "new 0 0 120 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-purple",
    d: "M59.6,8.2H18.3c-15.1,0.1-15,11-15.6,14.2l-0.2,1.2L0,39h41.4c15.1-0.1,15-11,15.6-14.2L59.6,8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M32.5,27.8h-5.2c-0.5-0.1-0.6-0.4-0.6-0.5l1.7-11.2h-4.1l-1.9,12.3c0,0,0,1.2,0.7,1.9c0.7,0.6,1.7,0.7,1.7,0.7 l7.2,0L32.5,27.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M42.6,15.9c-2.5,0.1-5.1,1-6.8,2.8c-1.3,1.4-2.1,3.3-2.4,5.1c-0.7,4.3,2.3,7.7,6.7,7.6c2.6-0.1,5.3-1.2,7-3.1 c1.2-1.3,1.9-3.1,2.2-4.8C50,19.2,47,15.8,42.6,15.9 M45.2,23.5c-0.4,2.4-2.5,4.2-4.7,4.2c-2.1,0-3.5-1.8-3-4.2 c0.4-2.4,2.5-4.1,4.6-4.1C44.3,19.4,45.6,21.1,45.2,23.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M22.2,16.1h-5.5h-2.2c-0.3,0-1.1,0.2-1.6,0.7c-0.3,0.3-0.5,0.8-0.6,1.1l-2,13.1h4.1l0.9-6h5.2l0.4-3.1h-5.1 l0.3-2c0,0,0.1-0.5,0.7-0.5l0,0h4.9L22.2,16.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-blue",
    d: "M120,0L78.7,0C63.5,0.1,63.7,11,63,14.3l-0.2,1.2l-2.5,15.4l41.3,0c15.1-0.1,15-11,15.6-14.3L120,0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M83.6,14.3l-1.2,7.5c0,0-2.5,1.3-6.2,1.3s-5.8-2.4-6.3-4.1c-0.5-1.7-0.4-5.4,1.6-7.7c2-2.3,4.4-3.7,9-3.4 C80.5,8,82,8,84,8.6l-0.6,3.2c0,0-4.2-1-6.5-0.1c-2.3,0.9-3.1,3.5-3.1,4.4c0,0.9,0.3,3.4,3,3.6c0.9,0.1,1.6,0,2.1-0.2l0.3-2.2 l-3.4,0l0.4-3L83.6,14.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M94.5,8h-3.5c-2,2.8-7.7,14.9-7.7,14.9l4.1,0l1.4-3.8h4.4c0.3,0.9,0.4,3.8,0.4,3.8h4.1 C96.5,14.4,94.5,8,94.5,8 M90,16.2l2.1-4.1l0.7,4.1H90z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "svg-white",
    d: "M111.4,8.8l-0.5,3.1c0,0-3.2-1.2-4.8-1c-1.6,0.2-2,0.7-2,1c0,0.3-0.5,1.2,1,1.5c1.3,0.3,3.2,1.1,4.4,1.9 c1.3,1,1.4,3.3,0.3,4.9c-1.2,1.8-2.4,2.5-5,2.7c-2.7,0.2-3.3-0.2-6-1.2l0.5-3.3c0,0,2.5,1.3,5,1.4c2.4,0,2.4-1.8,1.7-2.1 c-0.9-0.5-2.1-0.8-3.1-1.2c-0.5-0.2-3.4-1.2-2.9-4.2c0.6-3.4,3.8-4.8,6.7-4.7C109.6,7.7,111.4,8.8,111.4,8.8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be27fd801ed4a1ef19711f0108715562.svg";
export { ForwardRef as ReactComponent };